import {Component, EventEmitter, Inject, Input, Output, ViewChild} from '@angular/core';
import {Terminal} from '../model/terminal';
import {Questionnaire} from '../model/questionnaire';
import {GenericModalComponent} from '../modal/generic-modal.component';
import {ContentPreview} from '../model/contentPreview';
import {ProjectService} from '../project/project.service';
import {DOCUMENT} from '@angular/common';
import {StringUtil} from '../util/stringUtil';
import {TerminalUtil} from '../util/terminalUtil';


@Component({
    selector:'previewPane',
    template:`<div class="container">
        <p>Select your language for the preview</p>
        <div>
            <select [(ngModel)]="this.previewLanguage">
                <option *ngFor="let lang of langArr" [value]="lang">
                    {{lang}}
                </option>
            </select>
            <button type="button" class="btn btn-primary" (click)="renderPreview()">Generate Preview</button>
        </div>
        <br/>
        <br/>
        <p class="emailContent" *ngIf="this.htmlContent!=null" [innerHTML]=this.htmlContent.getHtmlContent()></p>
    </div>
    `,
    styles:[`
        .modal-dialog {
            max-width: 800px;
            margin:  auto;
        }
        .top{background-color: white;width: 100%;height:600px;}
        .container {
            margin: 50px auto 0;
            width:740px;
            height:1200px;
            background: #f5f5f5;
            padding: 45px;
            border-radius: 5px;
            border: solid 2px #777;
            box-shadow: 0 0 5px #333;
        }
        .modal-body{padding-left:50px; padding-right:50px; overflow-y:scroll; height:750px;}

        .emailContent{border-style: solid;border-width: thin;}

        .ContentSection{ padding-left: 20px;}

        .sectionTitle{font-size: large; font-weight: bold;}

        .mainTable{margin-left: 20px;}
        .borderGray{
            border: 1px solid #ccc;
        }

        .borderRed{
            border: 1px solid red;
        }
        .mainTable {width:100%;}
        .twitterTable{
            margin-left: 20px;
        }
        .downloadSection{
            margin-left: 20px;
        }
        .facebookTable{
            margin-left: 20px;
        }
        .mailPreviewWindow{height:40px;margin-top:-5px;}

        .modal-header{
            background-color:dodgerblue;
            color:antiquewhite;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }
        .modal-content{
            border-top-right-radius: 18px;
            border-top-left-radius: 18px;
        }
        .modal-title{margin-left:10px;}
        .closeX{color:azure;size:25px;}
        .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
        .btn-danger:hover{background-color: #FF2400;}
        .btn-primary{margin-left: 20px;}`]
})
export class ContentPreviewPaneComponent {

    @Input('hide') hide = true;
    @Input('isEmail') isEmail;
    @Input('title') title;
    @Input('path') path;

    /*@Input('terminal') terminal:Terminal;
    @Input('questionnaire') questionnaire:Questionnaire;*/

    @Input() pId = 0;
    @Input() qId = 0;
    @Input() tId = 0;
    @Input() terminalType='';

    @Input('langArr')  langArr:string[];
    @Output() alert:EventEmitter<any> = new EventEmitter();

    private htmlContent:ContentPreview;
    private _hideInfoModal =true;

    private previewLanguage:string;

    constructor(private _projectService: ProjectService,@Inject(DOCUMENT) public document) {

    }


    renderPreview() {

        if(this.previewLanguage == null || this.previewLanguage === '') {
          this.alert.emit(('Please select a language before generating a preview.'));
          return;
        }

        if(this.path===null || this.path === '') {
          this.alert.emit('Please load a template before rendering');
          return;
        }

        const tmpToken = StringUtil.generateTemporaryToken(this.pId,this.qId,this.tId,TerminalUtil.getTerminalTypeId(this.terminalType),this.previewLanguage);

        this._projectService.getPreview(tmpToken,this.isEmail,this.path,'',localStorage.getItem('Authorization')).subscribe( (rep)=> {
            console.log(rep);
            // emailHtml as emailPreview;
            this.htmlContent = new ContentPreview();this.htmlContent.setHtmlcontent(rep);

        });
    }

    onOk() {
        this._hideInfoModal = true;
    }
    closeDialog() {
        this.hide = true;
    }

    showDialog() {
        this.hide = false;
    }
}
